import type { TabConfig } from "@/components/shared/UniversalDetailPage/types/tab-types";
import type { Social_Media_Posts } from "@/src/gql/graphql";

// ============================================================================
// SOCIAL MEDIA POST DETAIL TABS CONFIGURATION
// ============================================================================
// Details tab renders generically from the config `fields` map (no custom
// component) via FieldsTabContent — the same generic renderer other entities
// use. The Activity tab reuses the shared company/contact-scoped activity
// renderer (only shown when the post is linked to a company or contact).
// ============================================================================

export const socialMediaPostDetailTabs: TabConfig<Social_Media_Posts>[] = [
  {
    id: "details",
    label: "Details",
    icon: "FileText",
    variant: "blue",
    group: "core",
    priority: 1,
    content: {
      type: "fields",
      layout: "grid",
      sections: [
        {
          id: "core",
          title: "Post",
          fields: ["title", "body", "status", "brand", "platforms", "media_kind"],
          layout: "grid",
          gridColumns: 2,
        },
        {
          id: "scheduling",
          title: "Scheduling",
          fields: ["scheduled_at", "published_at"],
          layout: "grid",
          gridColumns: 2,
        },
        {
          id: "classification",
          title: "Details",
          fields: ["tags", "location", "media_url", "thumbnail_url"],
          layout: "grid",
          gridColumns: 2,
        },
      ],
    },
  },
  {
    id: "activity",
    label: "Activity",
    icon: "Mail",
    variant: "purple",
    group: "activity",
    priority: 1,
    visible: (post) =>
      (typeof post.company_id === "string" && post.company_id.length > 0) ||
      (typeof post.contact_id === "string" && post.contact_id.length > 0),
    content: {
      type: "activity",
    },
  },
];

export const socialMediaPostDetailDefaultTab = "details";
